export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9118.201ac5f4.jpg";